import { z } from "zod";
import { Solana } from "../solana/solana-base";

export namespace SolanaStaking {
  export type DEPRECATED_WalletStakingInfo = {
    accounts: [];
    total_profit: Solana.SolAmount;
    total_stake: {
      active: Solana.SolAmount;
      inactive: Solana.SolAmount;
      // Must always be active + inactive
      total: Solana.SolAmount;
    };
  };

  export type StakeAmountSummary = {
    staked: Solana.SolAmount;
    transferring: Solana.SolAmount;

    unstaking: Solana.SolAmount;
    withdrawable: Solana.SolAmount;

    // This is the sum above the above 4
    total: Solana.SolAmount;
  };

  export type WalletStakingDetails = {
    validators_with_stake: Array<SolanaStaking.ValidatorWithStake>;
    stake_summary: StakeAmountSummary;
  };

  export type StakingReward = {
    reward: Solana.SolAmount;
    api_id: string; // Used for pagination
    credited_at: string;
    epoch: number;
    // Deprecated: we never actually used this anywhere, and it is not useful
    // since StakingReward combines multiple accounts, so we'd have to account
    // for the state of these individual accounts.
    // Last used in Glow iOS 1.2.1
    balance: Solana.SolAmount;
  };

  // Rent reserve for a stake account is ~0.002 SOL. We enforce a minimum double
  // than that because we don't want to create stake accounts where only 10% of
  // the balance is staked.
  export const STAKE_ACCOUNT_MINIMUM_BALANCE: Solana.SolAmount = {
    lamports: "4000000", // 0.004 SOL
  };

  export const STAKE_ACCOUNT_LAYOUT_SPAN = 200; // bytes

  export const ValidatorZ = z.object({
    apy: z.number().nullable(),
    avatar_url: z.string().nullable(),
    name: z.string(),
    vote_address: Solana.AddressZ,
  });

  export type Validator = z.infer<typeof ValidatorZ>;

  export type ValidatorWithStake = Validator & {
    staked: Solana.SolAmount;
    transferring: Solana.SolAmount;
    unstaking: Solana.SolAmount;
    withdrawable: Solana.SolAmount;
  };
}
